export class SetProgress {
  static readonly type = '[Engine Progress] set progress';
  constructor(public storyLoadProgress: number, public chunkLoadProgress: number) { }
}
